// client/src/constants/paymentMethods.js
export const PAYMENT_METHODS = [
  { value: 'card', label: 'Card', icon: 'CreditCard' },
  { value: 'apple_pay', label: 'Apple Pay', icon: 'Apple' },
  { value: 'google_pay', label: 'Google Pay', icon: 'Google' },
  { value: 'klarna', label: 'Klarna', icon: 'Payment' },
  { value: 'afterpay', label: 'Afterpay', icon: 'Payment' },
  { value: 'clearpay', label: 'Clearpay', icon: 'Payment' },
];
